"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdditionalPurposeSubCategory = void 0;
const type_utils_1 = require("@transcend-io/type-utils");
exports.AdditionalPurposeSubCategory = (0, type_utils_1.makeEnum)({
    /** Fallback sub purpose */
    Additional: 'ADDITIONAL',
});
//# sourceMappingURL=additional.js.map